export interface ValueMotive {
  abbr: string;
  description: string;
}

export interface ValueCluster {
  cluster_id: string;
  cluster_name: string;
  motives: ValueMotive[];
}

export const valuesData: ValueCluster[] = [
  {
    cluster_id: 'V1',
    cluster_name: 'Fairness & Social Justice',
    motives: [
      { abbr: 'Peace', description: 'A peaceful world' },
      { abbr: 'Equality', description: 'Equality for all people' },
      { abbr: 'Justice', description: 'Justice and fairness' },
    ],
  },
  {
    cluster_id: 'V2',
    cluster_name: 'Being a Good Person',
    motives: [
      { abbr: 'Honest', description: 'Being honest' },
      { abbr: 'Ethical', description: 'Being ethical and doing the right thing' },
      { abbr: 'Loyal', description: 'Being loyal' },
    ],
  },
  {
    cluster_id: 'V3',
    cluster_name: 'Friendships & Social Life',
    motives: [
      { abbr: 'ClsFriends', description: 'Having close friends' },
      { abbr: 'Popular', description: 'Being liked and popular' },
      { abbr: 'Communicate', description: 'Being able to express myself' },
    ],
  },
  {
    cluster_id: 'V4',
    cluster_name: 'Family',
    motives: [
      { abbr: 'Cls2Fam', description: 'Being close to my family' },
      { abbr: 'RespectEld', description: 'Respecting my elders' },
    ],
  },
  {
    cluster_id: 'V5',
    cluster_name: 'Personal Growth & Self-Knowledge',
    motives: [
      { abbr: 'PersGrwth', description: 'Growing and developing as a person' },
      { abbr: 'KnowSelf', description: 'Knowing and understanding myself' },
      { abbr: 'TrueToSelf', description: 'Being true to myself' },
    ],
  },
  {
    cluster_id: 'V6',
    cluster_name: 'Independence & Freedom',
    motives: [
      { abbr: 'Independent', description: 'Being independent' },
      { abbr: 'InControl', description: 'Being in control of my own life' },
    ],
  },
  {
    cluster_id: 'V7',
    cluster_name: 'Achievement & Success',
    motives: [
      { abbr: 'Ambitious', description: 'Being ambitious and hard-working' },
      { abbr: 'Mastery', description: 'Mastering things I set out to do' },
      { abbr: 'SuccInOccup', description: 'Being successful in my future career' },
    ],
  },
  {
    cluster_id: 'V8',
    cluster_name: 'Learning & Intelligence',
    motives: [
      { abbr: 'Education', description: 'Getting a good education' },
      { abbr: 'Curious', description: 'Being curious and learning new things' },
    ],
  },
  {
    cluster_id: 'V9',
    cluster_name: 'Creativity & Arts',
    motives: [
      { abbr: 'Creative', description: 'Being creative' },
      { abbr: 'LearnArts', description: 'Learning and appreciating the arts' },
    ],
  },
  {
    cluster_id: 'V10',
    cluster_name: 'Nature & Environment',
    motives: [
      { abbr: 'ProtectEnv', description: 'Protecting the environment' },
      { abbr: 'CareAnimals', description: 'Caring for animals' },
    ],
  },
  {
    cluster_id: 'V11',
    cluster_name: 'Leadership & Influence',
    motives: [
      { abbr: 'Leader', description: 'Being a leader' },
      { abbr: 'InspirOthrs', description: 'Inspiring others' },
    ],
  },
  {
    cluster_id: 'V12',
    cluster_name: 'Fun & Adventure',
    motives: [
      { abbr: 'Happy', description: 'Being happy' },
      { abbr: 'Adventurous', description: 'Being adventurous' },
      { abbr: 'ExcitngLife', description: 'Having an exciting life' },
    ],
  },
  {
    cluster_id: 'V13',
    cluster_name: 'Health & Fitness',
    motives: [
      { abbr: 'PhysHlth', description: 'Being physically healthy' },
      { abbr: 'PhysFit', description: 'Being physically fit' },
    ],
  },
  {
    cluster_id: 'V14',
    cluster_name: 'Inner Peace & Well-being',
    motives: [
      { abbr: 'FeelGoodSelf', description: 'Feeling good about myself' },
      { abbr: 'Harmony', description: 'Finding harmony and balance' },
    ],
  },
  {
    cluster_id: 'V15',
    cluster_name: 'Spirituality & Meaning',
    motives: [
      { abbr: 'ReligFaith', description: 'Having religious or spiritual faith' },
      { abbr: 'HigherMeaning', description: 'Finding deeper meaning in life' },
    ],
  },
];

export const interestOptions = [
  // Sports & Physical Activities
  'Basketball',
  'Soccer',
  'Swimming',
  'Dance',
  'Gymnastics',
  'Tennis',
  'Volleyball',
  'Baseball',
  'Track & Field',
  'Martial Arts',
  'Skateboarding',
  'Surfing',
  'Rock Climbing',
  'Yoga',
  'Cycling',
  'Hiking',
  'Running',
  'Football',
  'Ice Skating',
  'Skiing',

  // STEM & Technology
  'Biology',
  'Chemistry',
  'Physics',
  'Astronomy',
  'Robotics',
  'Coding',
  'Math',
  'Engineering',
  'Computer Science',
  'Web Design',
  'Game Development',
  'App Development',
  'AI & Machine Learning',
  '3D Printing',
  'Electronics',

  // Creative Arts
  'Painting',
  'Drawing',
  'Music',
  'Theater',
  'Photography',
  'Film Making',
  'Animation',
  'Graphic Design',
  'Digital Art',
  'Sculpture',
  'Pottery',
  'Crafts',
  'Fashion Design',
  'Jewelry Making',
  'Calligraphy',
  'Singing',
  'Playing Instruments',
  'Songwriting',
  'DJing',
  'Music Production',

  // Writing & Literature
  'Writing',
  'Reading',
  'Poetry',
  'Creative Writing',
  'Journalism',
  'Blogging',
  'Storytelling',
  'Comics & Graphic Novels',

  // Academic & Learning
  'History',
  'Languages',
  'Geography',
  'Psychology',
  'Philosophy',
  'Political Science',
  'Economics',
  'Anthropology',
  'Archaeology',
  'Literature',

  // Performing Arts
  'Acting',
  'Improv Comedy',
  'Stand-up Comedy',
  'Magic',
  'Puppetry',

  // Nature & Environment
  'Animals',
  'Nature',
  'Gardening',
  'Bird Watching',
  'Environmental Science',
  'Marine Biology',
  'Wildlife Conservation',
  'Camping',
  'Fishing',

  // Social & Community
  'Volunteering',
  'Community Service',
  'Debate',
  'Public Speaking',
  'Student Government',
  'Tutoring',
  'Mentoring',
  'Activism',
  'Fundraising',

  // Food & Culinary
  'Cooking',
  'Baking',
  'Food Science',
  'Nutrition',
  'Recipe Creation',

  // Games & Entertainment
  'Gaming',
  'Board Games',
  'Chess',
  'Puzzles',
  'Video Game Streaming',
  'Esports',
  'Card Games',
  'Tabletop RPGs',

  // Lifestyle & Hobbies
  'Travel',
  'Fashion',
  'Makeup & Beauty',
  'Interior Design',
  'Collecting',
  'Model Building',
  'Woodworking',
  'Sewing',
  'Knitting',
  'DIY Projects',

  // Business & Entrepreneurship
  'Entrepreneurship',
  'Business',
  'Marketing',
  'Social Media',
  'Investing',
  'Finance',
  'Event Planning',

  // Wellness & Mindfulness
  'Meditation',
  'Fitness',
  'Nutrition & Health',
  'Mental Health Advocacy',
];

export const interestCategories: Record<string, string[]> = {
  'Sports & Physical Activities': [
    'Basketball',
    'Soccer',
    'Swimming',
    'Dance',
    'Gymnastics',
    'Tennis',
    'Volleyball',
    'Baseball',
    'Track & Field',
    'Martial Arts',
    'Skateboarding',
    'Surfing',
    'Rock Climbing',
    'Yoga',
    'Cycling',
    'Hiking',
    'Running',
    'Football',
    'Ice Skating',
    'Skiing',
  ],
  'Arts & Music': [
    'Painting',
    'Drawing',
    'Photography',
    'Digital Art',
    'Sculpture',
    'Music',
    'Singing',
    'Playing Instruments',
    'Songwriting',
    'DJing',
    'Music Production',
    'Theater',
    'Acting',
    'Improv Comedy',
    'Stand-up Comedy',
    'Magic',
  ],
  'Crafts & Making': [
    'Pottery',
    'Crafts',
    'Fashion Design',
    'Jewelry Making',
    'Calligraphy',
    'Model Building',
    'Woodworking',
    'Sewing',
    'Knitting',
    'DIY Projects',
  ],
  'Science & Nature': [
    'Biology',
    'Chemistry',
    'Physics',
    'Astronomy',
    'Environmental Science',
    'Marine Biology',
    'Animals',
    'Nature',
    'Gardening',
    'Bird Watching',
    'Wildlife Conservation',
    'Camping',
    'Fishing',
  ],
  'Technology & Engineering': [
    'Coding',
    'Computer Science',
    'Web Design',
    'Game Development',
    'App Development',
    'AI & Machine Learning',
    'Robotics',
    'Engineering',
    '3D Printing',
    'Electronics',
  ],
  'Writing & Communication': [
    'Writing',
    'Reading',
    'Poetry',
    'Creative Writing',
    'Journalism',
    'Blogging',
    'Storytelling',
    'Comics & Graphic Novels',
    'Public Speaking',
    'Debate',
  ],
  'Academic Subjects': [
    'Math',
    'History',
    'Languages',
    'Geography',
    'Psychology',
    'Philosophy',
    'Political Science',
    'Economics',
    'Anthropology',
    'Archaeology',
    'Literature',
  ],
  'Community & Leadership': [
    'Volunteering',
    'Community Service',
    'Student Government',
    'Tutoring',
    'Mentoring',
    'Activism',
    'Fundraising',
  ],
  'Food & Cooking': ['Cooking', 'Baking', 'Food Science', 'Nutrition', 'Recipe Creation'],
  'Gaming & Entertainment': [
    'Gaming',
    'Board Games',
    'Chess',
    'Puzzles',
    'Video Game Streaming',
    'Esports',
    'Card Games',
    'Tabletop RPGs',
  ],
  'Media & Design': [
    'Film Making',
    'Animation',
    'Graphic Design',
    'Photography',
    'Social Media',
    'Marketing',
    'Event Planning',
  ],
  'Other Interests': [
    'Travel',
    'Fashion',
    'Makeup & Beauty',
    'Interior Design',
    'Collecting',
    'Meditation',
    'Fitness',
    'Nutrition & Health',
    'Mental Health Advocacy',
    'Entrepreneurship',
    'Business',
    'Investing',
    'Finance',
  ],
};
